export default {
  ShowDate: 2,
  ShowSoLan: 3,
};
